import { SiteWithDistance } from '@cinch-labs/sites-sdk'
import { LocationCardData } from './location-card'

export const buildCarouselSlideData = (
  sites: SiteWithDistance[],
): LocationCardData[][] => {
  const slides: LocationCardData[] = []

  for (const { site, distance } of sites) {
    const siteName = site.getFeatureAttribute('display_name')

    if (!siteName) continue

    const slug = site.getFeatureAttribute('slug')

    if (!slug || !slug.startsWith('wbac-')) continue

    const address = site.getFeatureAttribute('address')

    if (!address) continue

    slides.push({
      siteName,
      distance,
      // remove 'wbac-' from slug
      slug: slug.slice(5),
      address,
    })
  }

  const slidesPerChunk = 3
  const chunkedSlides: LocationCardData[][] = []

  for (let i = 0; i < slides.length; i += slidesPerChunk) {
    chunkedSlides.push(slides.slice(i, i + slidesPerChunk))
  }

  return chunkedSlides
}
